export default "__VITE_ASSET__$Nj27KmT__"